<div>
    <div [formGroup]="frmGroup">
        <div *ngIf="configData?.errorCount" [ngStyle]="$safeNavigationMigration(configData?.style)">
            <div class="error-bg-style" *ngIf="totalError > 0">
                <span>
                    <img src="../../../../assets/images/icons-error.svg" class="iconserror">
                </span>
                <span class="notification-text">
                    * {{totalError}} {{constant?.ERROR_MSG_COUNT}}
                </span>
            </div>
        </div>
        <div [formArrayName]="configData.name">
            <div *ngFor="let row of getFormTableControls(); let rowIndex = index" [ngClass]="{odd: rowIndex % 2 === 2}"
                style="margin:0px;">
                <div style="width:calc(100%-85px)">
                    <div *ngFor="let group of configData.groups;let grpIdx = index" [formGroupName]="rowIndex">
                        <div *ngIf="group.roleAccess;then roleAccess else default">

                        </div>
                        <ng-template #roleAccess>
                            <div *ngIf="isAccessible(group.roleAccess)">                                
                                <div *ngIf="group.showGroupEnrichmentMessage" class="substatus-msg">
                                 <div [innerHtml]= "group.groupEnrichmentMessage"> </div>
                                </div>
                                <div class="section-label" *ngIf="group.label && group.visibility !== false && !selfServiceConfig">{{group.label}}</div>
                                <div class="section-label" (click)="editFieldConfig('false','group.label','')" *ngIf="group.label && group.visibility !== false && selfServiceConfig" >{{group.label}}</div>
                                <div class="row">
                                    <div *ngFor="let control of group.controls"
                                        [ngClass]="getColumnsVisibility(control)" [class.hide]="control.colsHidden">
                                        <app-form-field [configData]="control"
                                            [frmGroup]="getFormTableControls()[rowIndex]">
                                        </app-form-field>
                                    </div>
                                </div>
                                <div *ngIf="grpIdx !== configData.groups.length && group.visibility !== false" class="section-align">
                                    <div class="section-divider"></div>
                                </div>
                                <!-- <div class="form-footer" *ngIf="group.footer">        
                                    <button type="button" style="width:100px;height:auto" class="btn buttons-secondary dhl-button-v2">Back</button>
                                    <button type="button" style="width:100px;height:auto" class="btn buttons-primary dhl-button-v2">Next</button>
                                </div> -->
                            </div>
                        </ng-template>
                        <ng-template #default>                            
                            <div *ngIf="grpIdx !== 0 && (group.showDividerLine === undefined || group.showDividerLine === true) && group.visibility !== false" class="section-align">
                                 <div class="section-divider"></div>
                            </div>
                            <div *ngIf="group.showGroupEnrichmentMessage" class="substatus-msg">
                                <div [innerHtml]= "group.groupEnrichmentMessage"> </div>
                            </div>
                            <div class="section-label" *ngIf="group.label && group.visibility !== false && !selfServiceConfig">
                                <div> {{group.label}}
                                </div>
                                <div *ngIf="group.groupLevelAction" class="group-level-action">  
                                    <app-additional-information-v2 [additionalInfo]="group.groupLevelAction" [configData] = "group"></app-additional-information-v2>                                    
                                </div>
                            </div>
                            <div (click)="editFieldConfig('false',group.label,'')" class="section-label" *ngIf="group.label && group.visibility !== false && selfServiceConfig">
                                <div> {{group.label}}</div>                                                                   
                                <div *ngIf="group.groupLevelAction" class="group-level-action">  
                                    <app-additional-information-v2 [additionalInfo]="group.groupLevelAction" [configData] = "group"></app-additional-information-v2>                                    
                                </div>
                            </div>
                            <div *ngIf="group?.infoBanner && group?.infoBanner?.isVisible" class="dhl-info-message">
                                <img src="../../../../assets/images/alpha-icons/icons-darkBlue-information.svg">
                                <strong>{{group?.infoBanner?.label}}</strong>
                                <span>{{group?.infoBanner?.message}}</span>
                            </div>
                            <div *ngIf="group.subLabel && group.subLabelEnable">
                                <span>
                                    <img src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,2260,24,24))" class="info-icon" type="image/svg+xml"/>
                                </span>
                                {{group.subLabel}}
                            </div>
                            <div  class="row"  *ngIf="!selfServiceConfig">
                                <div *ngFor="let control of group.controls; let crlIdx = index " [ngClass]="getColumnsVisibility(control)" [class.hide]="group.visibility === false || (getFormTableControls()[rowIndex].get(control.name)?.hidden && control.component !=='SPACEHOLDER_V2')" >
                                    <app-form-field [configData]="control"
                                        [frmGroup]="getFormTableControls()[rowIndex]">
                                    </app-form-field>
                                </div>
                            </div>
                            <div *ngIf="selfServiceConfig" class="row" cdkDropList (cdkDropListDropped)="drop($event,group.label)">
                                <div *ngFor="let control of group.controls; let crlIdx = index " cdkDrag [ngClass]="getColumnsVisibility(control)" [class.hide]="group.visibility === false || (getFormTableControls()[rowIndex].get(control.name)?.hidden && control.component !=='SPACEHOLDER_V2')" >
                                    <div *ngIf="selfServiceConfig" class="col mat-header-cell" style="font-size: 14px">
                                        <span (click)="removeFields($event,control,grpIdx,crlIdx)">
                                          <img src="./../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1170,24,24))">
                                      </span>
                                      <span (click)="editFieldConfig('false','updateField',control)">
                                        <img src='../../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,5025,24,24))'>
                                      </span>
                                      </div>
                                    <app-form-field [configData]="control"
                                        [frmGroup]="getFormTableControls()[rowIndex]">
                                    </app-form-field>
                                </div>
                            </div>
                            <span  *ngIf="selfServiceConfig"  (click)="editFieldConfig('false','addField',group.label)">
                                <img src="./../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1140,24,24))">
                                <span class="add-label">Add New Field</span>
                            </span>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="editField" class="dhl-form-self-service">
        <div class="sidemenu-header">
            <span class="dhl-icon-compoenent-cancel-v2" (click)="editFieldConfig('cancel','','')"></span>
        </div>    
        <app-form-comp *ngIf="templateData" (formStatus)="getFormStatus($event)"   (form)="getForm($event)" [configData]=templateData [orderDetails]="configData" [lableForConfig]="lableForConfig"></app-form-comp>
        <div class="sidemenu-header">
            <span class="dhl-icon-generic-form-field-v2" (click)="editFieldConfig('cancel','','')"></span>
        </div>
      </div>


    <!-- <div>
    <div [formGroup]="frmGroup" fxFlex>
        <div [formArrayName]="configData.name" fxFlex>
            <div *ngFor="let row of getFormTableControls(); let rowIndex = index"
                [ngClass]="{odd: rowIndex % 2 === 2}" style="margin:0px;">
                <div fxFlex="calc(100%-85px)">
                    <div class="row">
                        <div *ngFor="let control of configData.controls" [formGroupName]="rowIndex" class="col mat-cell"
                            [ngClass]="getColumnsVisibility(control)">
                            <app-form-field [configData]="control" [frmGroup]="getFormTableControls()[rowIndex]">
                            </app-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</div> -->